import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { MonitoringSeriesPoint } from '../types/monitoring';

interface MetricsChartProps {
  series: MonitoringSeriesPoint[];
}

function formatTimeLabel(value: string) {
  const date = new Date(value);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export default function MetricsChart({ series }: MetricsChartProps) {
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={series} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="timestamp" tickFormatter={formatTimeLabel} stroke="#94a3b8" />
          <YAxis
            yAxisId="left"
            stroke="#94a3b8"
            tickFormatter={(value) => `${value / 1000}k`}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke="#94a3b8"
            domain={[80, 100]}
            tickFormatter={(value) => `${value}%`}
          />
          <Tooltip
            formatter={(value: number, name: string) => {
              if (name === 'successRate') {
                return [`${value}%`, 'Success rate'];
              }
              if (name === 'recordsProcessed') {
                return [value.toLocaleString(), 'Records'];
              }
              return [value, name];
            }}
            labelFormatter={formatTimeLabel}
          />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="recordsProcessed"
            stroke="#2563eb"
            strokeWidth={2}
            dot={false}
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="successRate"
            stroke="#10b981"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
